<template>
  <b-card-group>
    <b-card no-body>
      <div class="card-body">
        <div>
          <b-form class="filter-form">
            <b-row>
              <b-col cols="1">
                <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                  <font-awesome-icon icon="times" />
                  {{ $t('Сброс') }}
                </b-button>
              </b-col>
              <filter-select
                :label="$t('Тип огранизации')"
                v-model="form.group"
                :options="groups"
                v-on:onChange="search"
              ></filter-select>
              <filter-input
                :label="$t('Код')"
                v-model="form.code"
                v-on:onBlur="search"
              ></filter-input>
              <filter-input
                :label="$t('Название')"
                v-model="form.name"
                v-on:onBlur="search"
              ></filter-input>
              <filter-checkbox
                :label="$t('Не действующие')"
                v-model="form.notActiveOnly"
                v-on:onChange="changeIsActive"
              ></filter-checkbox>
        
            </b-row>
          </b-form>
        </div>
      </div>
    </b-card>
  </b-card-group>
</template>

<script>
import axios from 'axios';
import BaseFilter from '@/models/base.filter';

export default {
  name: 'filter-form',
  extends: BaseFilter,
  props: {
    name: String,
    code: String,
    group: String,
    notActiveOnly: [String, Boolean],
  },
  data() {
    return {
      form: {
        group: this.group || '',
        name: this.name || '',
        code: this.code || '',
        notActiveOnly: this.notActiveOnly == 'true' || false,
      },
      groups: [],
    };
  },
  methods: {
    changeIsActive() {
      this.form.notActiveOnly = !this.form.notActiveOnly;
      this.search();
    },
    getDictionaries() {
      axios
        .get('/Dictionary/GetGroups')
        .then((response) => {
          this.groups = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
